export const TAG_REGEXP = /^[a-z0-9][a-z0-9_]*$/;

const SPACE_REGEXP = /\s+/g;
const NONWORD_REGEXP = /\W/g;

/**
 * Sanitize text to tag.
 * Replaces spaces with underscores and removes non-word characters.
 * Lowercases the result.
 */
export const toTag = (text: string): string | undefined => {
  const tag = text
    .replace(SPACE_REGEXP, "_")
    .replace("-", "_")
    .replace(NONWORD_REGEXP, "")
    .toLowerCase();

  if (tag === "_") return undefined;
  if (tag === "") return undefined;

  return tag;
};

/** Display tag as #hashtag with leading `#` */
export const toHashtag = (text: string): string | undefined => {
  const tag = toTag(text);
  if (tag !== undefined) {
    return `#${tag}`;
  }
};
